import styled from 'styled-components';

import { TextInput } from '@sternum/ui';

export const AutocompleteDropdownTextInput = styled(TextInput)`
  overflow: auto;
  text-overflow: ellipsis;
  border-bottom: none;
`;
